<div class="profile-settings-container">
  <div class="profile-header">
    <button class="back-button" (click)="goBack()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      Geri
    </button>
    <h1>Profil Ayarları</h1>
  </div>

  <div class="profile-content" *ngIf="!isLoading; else loadingTemplate">
    <div class="profile-picture-section">
      <div class="picture-wrapper">
        <img [src]="getDisplayPictureUrl()" alt="Profil Fotoğrafı" class="profile-picture"
          (error)="onImageError($event)">
        <div class="picture-overlay">
          <label for="file-input" class="upload-button">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
            </svg>
            Fotoğraf Yükle
          </label>
          <input type="file" id="file-input" accept="image/*" (change)="onFileSelected($event)" style="display: none;">
        </div>
      </div>
      <button *ngIf="selectedFile" class="save-picture-button" (click)="uploadProfilePicture()" [disabled]="isSaving">
        {{ isSaving ? 'Yükleniyor...' : 'Kaydet' }}
      </button>
    </div>

    <div class="profile-form">
      <div class="form-group">
        <label for="name">İsim</label>
        <input type="text" id="name" [(ngModel)]="name" placeholder="İsminizi girin" [disabled]="isSaving">
      </div>

      <div class="form-group">
        <label for="username">Kullanıcı Adı</label>
        <input type="text" id="username" [value]="profile?.username" disabled>
      </div>

      <div class="form-group">
        <label for="role">Rol</label>
        <input type="text" id="role" [value]="profile?.role" disabled>
      </div>

      <div class="form-group password-field-group">
        <label>Parola</label>
        <div class="input-with-icon">
          <input type="text" value="••••••••" disabled>
          <button type="button" class="edit-icon-button" (click)="togglePasswordForm()"
            [class.active]="showPasswordForm" [title]="showPasswordForm ? 'Vazgeç' : 'Şifre Değiştir'">
            <svg *ngIf="!showPasswordForm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
              <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
            </svg>
            <svg *ngIf="showPasswordForm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- Password Change Section -->
      <div class="password-form-card" *ngIf="showPasswordForm">
        <div class="password-form-header">
          <h3>Şifre Değiştir</h3>
        </div>
        <div class="password-form-body">
          <div class="form-group">
            <label for="currentPassword">Mevcut Şifre</label>
            <input type="password" id="currentPassword" [(ngModel)]="currentPassword"
              placeholder="Mevcut şifrenizi girin" [disabled]="isChangingPassword">
          </div>

          <div class="form-group">
            <label for="newPassword">Yeni Şifre</label>
            <input type="password" id="newPassword" [(ngModel)]="newPassword" placeholder="En az 6 karakter"
              [disabled]="isChangingPassword">
          </div>

          <div class="form-group">
            <label for="confirmPassword">Yeni Şifre (Tekrar)</label>
            <input type="password" id="confirmPassword" [(ngModel)]="confirmPassword"
              placeholder="Yeni şifrenizi tekrar girin" [disabled]="isChangingPassword">
          </div>

          <div class="error-message" *ngIf="passwordError">
            {{ passwordError }}
          </div>

          <div class="password-actions">
            <button class="change-password-button" (click)="changePassword()" [disabled]="isChangingPassword">
              {{ isChangingPassword ? 'Güncelleniyor...' : 'Şifreyi Güncelle' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Timeout Settings Section -->
      <div class="timeout-settings-section">
        <h3>Otomatik Mesaj Süreleri</h3>
        <p class="timeout-description">
          Otomatik mesaj ve timeout sürelerini dakikaya göre ayarlayın.
        </p>

        <div class="form-group">
          <label for="unansweredRequestThreshold">Kaptan Yanıt Vermezse Otomatik Mesaj (Dakika)</label>
          <div class="timeout-input-group">
            <input type="number" id="unansweredRequestThreshold" [(ngModel)]="unansweredRequestMinutesThreshold" min="1"
              max="1440" placeholder="1-1440 dakika" [disabled]="isSavingTimeout">
          </div>
          <small class="hint">Örnek: 3 dakika</small>
        </div>

        <div class="form-group">
          <label for="requestTimeout">Talep Timeout Süresi (Dakika)</label>
          <div class="timeout-input-group">
            <input type="number" id="requestTimeout" [(ngModel)]="requestTimeoutMinutes" min="3" max="1440"
              placeholder="3-1440 dakika" [disabled]="isSavingTimeout">
          </div>
          <small class="hint">Minimum: 3 dakika, Maksimum: 1440 dakika (24 saat)</small>
        </div>

        <div class="error-message" *ngIf="timeoutError">
          {{ timeoutError }}
        </div>
      </div>

      <!-- Working Hours Settings Section -->
      <div class="working-hours-settings-section">
        <h3>Çalışma Saatleri</h3>
        <p class="working-hours-description">
          Kaptan panelinin yeni talepleri kabul edeceği çalışma saatlerini belirleyin.
        </p>

        <div class="form-group">
          <label>Çalışma Saatleri</label>
          <div class="working-hours-input-group">
            <input type="time" [(ngModel)]="workingHoursStart" (ngModelChange)="onWorkingHoursChange()"
              [disabled]="isSavingWorkingHours || isLoadingWorkingHours">
            <span class="time-separator">–</span>
            <input type="time" [(ngModel)]="workingHoursEnd" (ngModelChange)="onWorkingHoursChange()"
              [disabled]="isSavingWorkingHours || isLoadingWorkingHours">
          </div>
          <small class="hint">Örnek: 09:00 - 22:00</small>
        </div>

        <div class="error-message" *ngIf="workingHoursError">
          {{ workingHoursError }}
        </div>
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="form-actions">
        <button class="save-button" (click)="saveAll()" [disabled]="isSaving">
          {{ isSaving ? 'Kaydediliyor...' : 'Kaydet' }}
        </button>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <div class="spinner"></div>
      <p>Yükleniyor...</p>
    </div>
  </ng-template>
</div>

<app-dialog *ngIf="showDialog" [config]="dialogConfig" (close)="onDialogClose()" (confirm)="onDialogClose()">
</app-dialog>